import React from 'react';
import MediaQueries from 'react-responsive';

import Page from 'marketing-website/components/modules/Page';
import HeroMedia from 'marketing-website/components/modules/Hero/HeroMedia';
import Whitespace from 'marketing-website/components/commons/Whitespace';
import Cta from 'marketing-website/components/modules/Cta/CtaDefault';
import metaData from 'marketing-website/data/metadata.js';

import DesignBlock from './DesignBlock';
import InterfacesBlock from './InterfacesBlock';
import PhotosBlock from './PhotosBlock';
import ToolsBlock from './ToolsBlock';

const PAGE_COLOR = 'yellow';
const buttons = [
  {
    text: 'Sign up free',
    link: '/signup/',
    styles: {
      shape: 'rounded',
      size: 'large',
      minWidth: 160,
    },
  },
  {
    text: 'Explore Plans',
    link: '/pricing/',
    styles: {
      shape: 'rounded',
      size: 'large',
      hover: 'green',
      kind: 'ghost',
      minWidth: 160,
    },
  },
];

export default function FeatureDesign() {
  return (
    <Page
      title={metaData.features.design.title}
      meta={[
        {
          name: 'description',
          content: metaData.features.design.description,
        },
        {
          name: 'keywords',
          content: metaData.features.design.keywords,
        },
      ]}
      header={{ isLight: true }}
      footer
    >
      <HeroMedia
        backgroundColor={PAGE_COLOR}
        color="white"
        tag="h1"
        headline="Designing online, made simple. No software or experience required."
        headlineMaxWidth={960}
        name="mkt_features_design"
        type="video"
      />
      <Whitespace sizeM="xl" />
      <DesignBlock color={PAGE_COLOR} />
      <ToolsBlock color={PAGE_COLOR} />
      <MediaQueries minWidth={770}>
        <Whitespace size="s" sizeM="xl" />
      </MediaQueries>
      <InterfacesBlock color={PAGE_COLOR} />
      <PhotosBlock />
      <Cta
        maxWidth={500}
        title="Join over 2 million people designing with Marvel. Get started for free."
        buttons={buttons}
      />
    </Page>
  );
}



// WEBPACK FOOTER //
// ./src/pages/features/design/index.js